var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',{attrs:{"layout":"main"}},[_c('gnb'),_c('full-page',{ref:"fullPage",attrs:{"options":_vm.options}},[_c('finbridge'),_c('enterprise-value'),_c('pass-prime'),_c('safe-guard'),_c('main-career'),_c('main-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }